export enum ReportType {
  Portfolio = 1,
  Project,
  Review_Agenda,
  Review,
  Accordance = 7,
  Customizable,
  Alert = 10,
}
